module.exports = __webpack_public_path__ + "static/media/sense4106.dbe7f4e8.jpg";